export const CARD_HEIGHT = "248px";
